import React, { useState, useRef, useEffect } from "react";
import "@wistia/wistia-player";
import VideoThumbnail from "../../assets/images/home-video-thumbnail.webp";
import PlayIcon from "../../assets/images/play-icon.webp";
import PlayIconTesti from "../../assets/images/play-icon-testi.webp";
import DownArrow from "../../assets/images/arrow-down.webp";
import HomeAward from "../../assets/images/home-award.webp";
import TeamHome from "../../assets/images/team-home.webp";
import Favicon from "../../assets/images/logo-fav.webp";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

import CustomModal from "../Model/CustomModal";
export const HomeContent = () => {
  const [openVideo, setOpenVideo] = useState(false);
  const [currentMediaId, setCurrentMediaId] = useState(null);

  const [isPlaying, setIsPlaying] = useState(false);

  const [activeTab, setActiveTab] = useState(0);
  const videoRefs = useRef([]);
  const observerRef = useRef(null);

  // Set up Intersection Observer to detect which video is in view
  useEffect(() => {
    if (observerRef.current) observerRef.current.disconnect();

    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = videoRefs.current.indexOf(entry.target);
            if (index !== -1) {
              setActiveTab(index);
            }
          }
        });
      },
      { threshold: 0.5 }
    ); // Adjust threshold as needed

    videoRefs.current.forEach((video) => {
      if (video) observerRef.current.observe(video);
    });

    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, []);

  const handleTabClick = (index) => {
    setActiveTab(index);
    if (videoRefs.current[index]) {
      const offsetTop =
        videoRefs.current[index].getBoundingClientRect().top +
        window.pageYOffset -
        100; // Adjust -100 to your desired offset
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };

  const location = useLocation();
  const navigation = useNavigate();
  useEffect(() => {
    const { search } = location;
    const containerId = search.substring(4); // Remove the leading slash
    const element = document.getElementById(containerId);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "center",
      });
    }
  }, [location]);

  const handsOnContent = [
    {
      videoSrc: `${process.env.PUBLIC_URL}/videos/entrepreneurship.mp4`,
      mediaPara:
        "Emphasis on Entrepreneurship Training as success lies in understanding the Business fully and totally",
      thumbImg: require("../../assets/images/home-course/entrepreneurship.webp"),
    },
    {
      videoSrc: `${process.env.PUBLIC_URL}/videos/knowledge.mp4`,
      mediaPara:
        "Tested Knowledge & Market-Ready Training which can be implemented right away",
      thumbImg: require("../../assets/images/home-course/knowledge.webp"),
    },
    {
      videoSrc: `${process.env.PUBLIC_URL}/videos/training.mp4`,
      mediaPara:
        "Data-Driven, Customer-Centric, Agency-Based, Performance-Oriented Strategies & Training",
      thumbImg: require("../../assets/images/home-course/training.webp"),
    },
    {
      videoSrc: `${process.env.PUBLIC_URL}/videos/methodology.mp4`,
      mediaPara:
        "Blended Model with a Practical and End-to-End Training Approach",
      thumbImg: require("../../assets/images/home-course/methodology.webp"),
    },
    {
      videoSrc: `${process.env.PUBLIC_URL}/videos/community.mp4`,
      mediaPara:
        "A Community of Positive like-minded individuals where one can collaborate, hire, outsource and build together with a win-win mindset",
      thumbImg: require("../../assets/images/home-course/community.webp"),
    },
    {
      videoSrc: `${process.env.PUBLIC_URL}/videos/continuous-learning.mp4`,
      mediaPara:
        "Continuous & Extended Knowledge Transfer even after course completion so students can be self-reliant",
      thumbImg: require("../../assets/images/home-course/continuous-learning.webp"),
    },
    {
      videoSrc: `${process.env.PUBLIC_URL}/videos/instructors.mp4`,
      mediaPara:
        "Taught by Who’s Who of the Industry, Complete Experts in their Domain Experience",
      thumbImg: require("../../assets/images/home-course/instructors.webp"),
    },
    {
      videoSrc: `${process.env.PUBLIC_URL}/videos/business-101.mp4`,
      mediaPara:
        "Complete Training from understanding the business to getting & working with clients and scaling the business",
      thumbImg: require("../../assets/images/home-course/business-101.webp"),
    },
    {
      videoSrc: `${process.env.PUBLIC_URL}/videos/resources.mp4`,
      mediaPara:
        "Helping Members visualise the bigger opportunities through showing real-world scenarios",
      thumbImg: require("../../assets/images/home-course/resources.webp"),
    },
    {
      videoSrc: `${process.env.PUBLIC_URL}/videos/mentorship.mp4`,
      mediaPara:
        "Dedicated Guidance through Action-Oriented Implementable Frameworks, along with peer-to-peer communication and support",
      thumbImg: require("../../assets/images/home-course/mentorship.webp"),
    },
  ];

  const [isPlaying1, setIsPlaying1] = useState(
    Array(handsOnContent.length).fill(false)
  );
  const handlePlay = (index) => {
    setIsPlaying1((prevState) => {
      const newState = [...prevState];
      newState[index] = true;
      return newState;
    });
  };

  const videos = [
    {
      thumbImg: require("../../assets/images/result-testi/1.SEA Thumbnail Ganesh.webp"),
      mediaId: "7u2k1g6s96",
      heading:
        "How Ganesh was able to make 26 Lakh in Profit with 1000 Rupees.",
      para: "Ganesh, a real estate business owner frustrated with unreliable agencies, self-learned digital marketing but struggled with the terminology. Joining Social Eagle Academy resolved his doubts in a month. He ran successful ads, earning 26 lakhs from one sale. He then launched his agency and became a digital strategist.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/2.SEA Thumbnail Richerd.webp"),
      mediaId: "abdz3imvg1",
      heading:
        "Richerd Made over 23 Lakh and also increased this Team Size by 3X.",
      para: "Richard, a digital marketer and business owner, faced financial struggles and lost confidence. Joining Social Eagle’s program connected him with supportive peers, boosting his motivation. He earned over 20 lakhs and won the Eagle Award at the TN Digital Summit.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/3.SEA Thumbnail Maheswari.webp"),
      mediaId: "2ofw3e9nox",
      heading:
        "How Maheswari Made Over 20 Lakhs in Revenue by Leveraging Digital Marketing in 3 Months.",
      para: "Maheswari runs Osai Media, a media company. Despite having her own agency, she wanted to upskill and help her clients transition to digital marketing. After joining Social Eagle’s Mentorship Program, she started upselling digital services and onboarding new clients. Using her new skills in other businesses, she comfortably made over 16 lakhs in 3 months.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/4.SEA Thumbnail Kamalakannan.webp"),
      mediaId: "rsdlzuxwhn",
      heading:
        "How Kamal turned into an Entrepreneur from an Employee while making more than 20 Lakhs in revenue.",
      para: "Kamal was a Corporate Employee and was helping his wife’s small business. He wanted to learn Digital Marketing to help his wife and in the process he started his own agency. He built Social Guru and now it is one of the renowned agencies in Dindigul, Tamil Nadu.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/5.SEA Thumbnail Mark Marimuthu.webp"),
      mediaId: "pyt49lf1lg",
      heading:
        "How Mark Marimuthu Made Over 20 Lakhs by Integrating Digital Marketing into His Existing Business.",
      para: "Mark Marimuthu runs a traditional media business. He wanted to add digital marketing services, so he joined Social Eagle’s Mentorship Program. By upselling digital marketing to his clients and offering combined services, he earned over 20 lakhs in less than 5 months.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/6.SEA Thumbnail Ameenur.webp"),
      mediaId: "xagsewhadg",
      heading:
        "How Ameenur Made Over 20 Lakhs in Revenue from Part-time Work in His Business.",
      para: "Ameenur, a full-time employee in Germany, runs two part-time businesses. After struggling despite joining many courses, he joined Social Eagle’s Digital Entrepreneurship Program, found the missing link, and now earns 2-3 lakhs every two weeks through webinars.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/7.SEA Thumbnail Ramesh.webp"),
      mediaId: "onc6flwghu",
      heading:
        "How Ramesh was able to get 4 New Clients Every Month for his agency services.",
      para: "Ramesh quickly shifted from being a professor to owning an agency within just 40 days of starting to learn Digital Marketing. Mastering everything from strategy creation to high-ticket sales boosted his confidence, securing him four clients monthly. He's now expanding his team.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/8.SEA Thumbnail Mukesh.webp"),
      mediaId: "uj51xtbu0a",
      heading: "How Mukesh bought his first car in 90 daysThrough Freelancing.",
      para: " Having spent more than 11L rupees in various other courses, Mukesh was not able to find the depth of digital marketing until he found the right knowledge and mentors at Social Eagle",
    },
    {
      thumbImg: require("../../assets/images/result-testi/9.SEA Thumbnail Alex Vibin.webp"),
      mediaId: "rfd2t49pg0",
      heading:
        "How Alex Vibin Grew His E-Commerce Brand and Started Two Other Businesses, Earning Over 10 Lakhs",
      para: "Alex Vibin, founder of Noobie Kid, an e-commerce brand selling kids toys, struggled with consistent sales through organic content. After joining the Digital Entrepreneurship Program, he started running ads, doubling his sales predictably. He also started a digital marketing agency and a tourism company, leveraging digital marketing to succeed.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/10.SEA Thumbnail Navaneetha.webp"),
      mediaId: "x1ybdl8ij9",
      heading:
        "How Navaneetha made more than 10 Lakhs after a Comeback from Career Break!",
      para: "Navaneetha, a housewife living in Saudi Arabia, began learning digital marketing to do something after a Career Break. After a 30-day course, she started her own Marketing agency, helping brands build authority on Social Media. Now, she has made more than 10 lakhs and chooses her clients. Her Success lies in her Collaborating power with the talents inside and outside the community.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/11.SEA Thumbnail Ragothaman.webp"),
      mediaId: "hjworhiwhn",
      heading:
        "How Ragothaman made more than 10 Lakhs in Revenue for his Real Estate Business!.",
      para: "Ragothaman, who runs a real estate business in Chennai, was frustrated with not getting qualified leads despite paying for third-party platforms. He decided to learn digital marketing to generate his own leads. After completing the course, he successfully generated leads from his ads and earned over 10 lakhs in revenue. Now, he’s confident and is scaling his business.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/37.SEA Thumbnail Abirami.webp"),
      mediaId: "rr6nu1fqui",
      heading: "How Abirami Became an Entrepreneur instead of an Employee",
      para: " Abirami became a housewife after moving to Dubai with her husband, putting her career dreams on hold. With 5 years of SEO experience, she wanted to restart her career but lacked a clear path. She joined Social Eagle Academy’s Digital Entrepreneurship Course, initially planning to find a job afterward. However, within 30 days, she started her own business and is now making five figures in revenue.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/13.SEA Thumbnail Naveen.webp"),
      mediaId: "oq7cthiyw7",
      heading:
        "How Naveen was able to make More than 7 Lakhs as an agency owner after failing in his 3 other businesses.",
      para: "Naveen, a first-time entrepreneur and mechanical engineer, had several failed businesses before joining Social Eagle. Now, after completing the Digital Entrepreneurship Initiator Program, he successfully runs a five-figure agency alongside his engineering career.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/14.SEA Thumbnail Priya.webp"),
      mediaId: "4zd36w6ie3",
      heading:
        "How a Corporate Employee like Priya was able to make more  than 5 Lakh with her side business using Digital Marketing",
      para: "Priya, originally an employee, joined Social Eagle Academy to learn digital marketing and assist her company. Discovering her passion, she began side hustles alongside her job, earning over 5 lakhs in five months.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/15.SEA Thumbnail Jeyasudha.webp"),
      mediaId: "80z8jx9epp",
      heading: "How Jeyasudha was able to earn 6+ Lakhs as an housewife.",
      para: "Jeyasudha, a former employee on a career break post-marriage, sought work-from-home opportunities. Discovering Social Eagle Academy's Digital Entrepreneurship Initiator Course, she secured her first client in under 30 days and now serves over 5 clients, earning over 6 lakh in revenue within 3 months.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/16.SEA Thumbnail Anitha.webp"),
      mediaId: "lju3ufacoo",
      heading: "How Anitha Made Over 5 Lakhs with Digital Marketing",
      para: "Anitha, a housewife living in Dubai, began learning digital marketing to help her husband's business. After a 30-day course, she started her own content marketing agency, helping brands build authority on LinkedIn. Now, she earns over 5 lakhs and chooses her clients.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/17.SEA Thumbnail Sunitha.webp"),
      mediaId: "k7msiy3rrb",
      heading: "How Sunitha Made Over 5 Lakhs in 60 Days",
      para: "Sunitha, a PhD scholar and healthcare consultant, was about to join a year-long digital marketing course. Instead, she joined Social Eagle after learning about Dharaneetharan and his team. Implementing what she learned and earning additional certifications, she became a LinkedIn Personal Branding Expert. Serving clients, she made over 5 lakhs in less than 60 days.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/18.SEA Thumbnail Vinothini.webp"),
      mediaId: "d6jzrvsx48",
      heading:
        "How Vinothini was able to grow her offline Boutique’s sales by 3X during off-season.",
      para: "Vinothini runs a boutique for kids party wear online and offline, a unique niche. After taking multiple courses with mixed results, she found success with mentorship from Social Eagle Academy. Implementing her new knowledge, she received over 1000 inquiries in the first week and made sales exceeding 8 lakhs within 30 days.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/19.SEA Thumbnail Giriesh.webp"),
      mediaId: "u6nxrhdu7i",
      heading:
        "How Giriesh helped his client make over $3000 with an investment of 1000 rupees.",
      para: "Giriesh, being a digital marketer was able to narrow his interest into funnels and email marketing while working with his clients. Now he is helping his e-com clients make $600 - $1000. He got this direction after he found the right knowledge and mentors at Social Eagle.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/20.SEA Thumbnail Karthik Raja.webp"),
      mediaId: "dqjap5tt8n",
      heading:
        "How Karthik Raja Earned more than 7 Lakhs without any Tech Experience",
      para: " Karthik runs a small business in southern Tamil Nadu with no prior tech experience. After learning digital marketing from Social Eagle Academy, he successfully generated leads for his real estate business. Interestingly, he began offering lead generation services to other businesses, starting his own agency and earning over 7 lakhs.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/21.SEA Thumbnail Sanjay.webp"),
      mediaId: "4l6znlv60g",
      heading:
        "How Sanjay Earns an Extra 1 Lakh as a Freelancer While Working Full-Time",
      para: "Sanjay is a digital marketing executive. His full-time job doesn't pay enough. He joined to earn an extra 1 lakh rupees as a freelancer. By using the Community's support, he reached his goal in less than 20 days after joining the Digital Entrepreneurship Program.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/22.SEA Thumbnail Jamuna.webp"),
      mediaId: "ioem04k50a",
      heading:
        "How Jamuna is making a profit of over 1 Lakh rupees for her Gift Shop Business.",
      para: "Jamuna was struggling to find a way to promote her offline gift shop in online. She tried multiple ways which she found was not helpful until she joined the Digital Entrepreneurship Initiator Program at Social Eagle.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/23.SEA Thumbnail Muthu Kumar.webp"),
      mediaId: "asoipzigg3",
      heading:
        "How Muthu Kumar added Digital Marketing to His Consulting Business and Earns Over 1 Lakh Each",
      para: "MonthMuthu Kumar runs a manufacturing consulting business, training people on processes and sales. After mentorship from Social Eagle Academy, he added digital marketing services to his offerings. Now, he earns an extra 1 lakh every month alongside his consulting business.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/24.SEA Thumbnail Kannan.webp"),
      mediaId: "h16jza2k15",
      heading:
        "How Kannan Increased His Client Base by 55% in less than 20 Days and is earning 4L/month",
      para: "Kannan, founder of Growpix, a digital marketing agency, wanted to grow his business beyond 10 clients. After joining the Digital Entrepreneurship Program, he helped clients earn over 35 lakhs in 40 days. This success led to many referrals, increasing his client base by 55% in less than 20 days.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/25.SEA Thumbnail Santhosh.webp"),
      mediaId: "b1jfys9j0q",
      heading: "How Santhosh made 36 times Returns for his Business.",
      para: "Santhosh, who runs three different businesses, wanted to learn digital marketing to better understand his team's work. Interestingly, he now runs his own campaigns and manages his team more effectively. His efforts have resulted in a 36x return on investment for his businesses.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/26.SEA Thumbnail Rajeswari.webp"),
      mediaId: "al5dy58ox4",
      heading:
        "Rajeswari earned over 3.8 Lakhs and Recreated her Identity after a Career Break",
      para: "Rajeswari, a housewife and former HR professional, took a career break after marriage but wanted to become independent again. She joined Social Eagle’s Digital Marketing Course and began by training others in digital marketing. She then started helping small businesses increase visibility and profits through her digital marketing services.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/27.SEA Thumbnail Shamrin.webp"),
      mediaId: "jb1ka033to",
      heading:
        "How Shamrin was able to make more than 2.6 Lakhs in 2 months with Digital Marketing!",
      para: "Shamrin wanted to help her husband’s printing business, so she started learning digital marketing. After completing the course, she launched her own agency. One of her clients even bought her a complete computer setup, and she used her earnings to start a physical office. She has made over 2.6 lakhs through digital marketing.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/28.SEA Thumbnail Jahir.webp"),
      mediaId: "vnbqwt8bko",
      heading: "Jahir earned over 2.4 Lakhs as an Extra Income.",
      para: " Jahir, a public speaking trainer, wanted to learn digital marketing because his friends were talking about it. He chose Social Eagle for his learning journey. While studying, he secured three speaking assignments and now uses digital marketing to grow his training business. Additionally, he helps other businesses generate leads, earning an extra 60K per month and has made over 2.4 lakhs so far.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/29.SEA Thumbnail Senthil Kumar.webp"),
      mediaId: "1c27fxuqjx",
      heading:
        "Senthil Kumar made over 2.3 Lakhs by providing Digital Marketing Services",
      para: "Senthil Kumar wanted to learn digital marketing to grow his medical equipment business. After completing the course, he used digital marketing to expand his business and also started his own agency. Through his agency, he made over 2.3 lakhs and even secured a deal with a government agency.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/30.SEA Thumbnail Ram Kumar.webp"),
      mediaId: "yuonw7a0su",
      heading: "How Ram Kumar Landed Big Clients billing Over 2 Lakhs",
      para: "Ram Kumar wanted to leave his current job. After joining Social Eagle Academy’s Mentorship Program and applying what he learned, he secured a major client deal worth over 7 lakhs in less than 30 days. Now, he is happily working as a digital entrepreneur.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/31.SEA Thumbnail Ashwin Krishna.webp"),
      mediaId: "q1htm1eraw",
      heading:
        "Ashwin Krishna made more than 5X Return on Investment in 60 days",
      para: "Ashwin, who runs a trading academy, was already using digital marketing but wanted to scale more efficiently. After joining Social Eagle, he began generating high-quality leads and conversions for his academy. Now, he also works with leading content creators and educators in the region, helping them with lead generation and sales.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/32.SEA Thumbnail Pavithra.webp"),
      mediaId: "71nqsiljho",
      heading:
        "Pavithra made 2 times the returns through collaboration inside the community",
      para: "Pavithra, a housewife and graphic designer helping her father’s printing business, wanted to recreate her identity and make a career comeback. After trying various approaches without success, she began collaborating with the Social Eagle Academy community. In less than 6 months, she earned over twice her investment. Her grit and determination were key to her success.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/33.SEA Thumbnail Kishore.webp"),
      mediaId: "1padnfbixe",
      heading:
        "Kishore earned the Respect he always wanted from his loved ones by making 1L+ in 30 days",
      para: "Kishore, a graduate helping with his father’s business, felt unfulfilled and lacked respect at home and among friends. Determined to make a name for himself, he joined Social Eagle Academy’s Digital Marketing Course. In less than 30 days, he earned over 1 lakh rupees and gained the respect he had longed for from his loved ones.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/34.SEA Thumbnail Selva Mariammal.webp"),
      mediaId: "w4y0kj361h",
      heading: "Selva Mariammal Made over 1.5 Lakh while working from home.",
      para: "Selva Mariammal, a housewife, wanted to work from home while spending time with her kids. With a passion for design, she decided to learn digital design and joined Social Eagle. After completing the course, she interned with entrepreneurs from the community, gaining real-time, practical experience. She then landed an opportunity to work with a renowned brand, allowing her to work from home and still be with her kids. She has made over 1.5 lakhs so far while working from home.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/35.SEA Thumbnail Jessy Priya.webp"),
      mediaId: "fks3f7kx3x",
      heading:
        "Jessy Priya Became the Family’s Breadwinner after marriage while earning over 1 Lakh",
      para: "Jessy Priya, a housewife, became a digital marketer after joining Social Eagle’s course. She started small, collaborating within the community, and used a 'value first, get paid later' strategy. This approach helped her earn more than she had invested, and she has now become the primary breadwinner of her family while earning over 1 Lakhs in revenue.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/36.SEA Thumbnail Selva Basti.webp"),
      mediaId: "hbsubfob8q",
      heading:
        "How Selva Basti earned 4 times more than his Salary in 2 Months!",
      para: "Selva Basti, a salaried employee, joined Social Eagle’s Digital Marketing Course to learn a new skill. By the end of the course, he joined networking forums, began offering digital marketing training, and gained clients. In less than 2 months, he earned 4 times more than his previous salary.",
    },

    {
      thumbImg: require("../../assets/images/result-testi/45.SEA Thumbnail Davibala.webp"),
      mediaId: "in56ak6aiq",
      heading: "How Devibala Turned High Clicks Into ₹15K Profit With Zero Experience",
      para: "Devibala, with zero experience in digital marketing, was frustrated with high clicks but low sales after launching her first Meta ad for a calendar manufacturer. Instead of giving up, she shifted to a lead generation strategy. The result? ₹15K earned and paid in full. With the right approach, she turned clicks into revenue and proved that experience isn’t a barrier to success.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/44.SEA Thumbnail Satish.webp"),
      mediaId: "phrg3mv8eu",
      heading: "How Sathish Made ₹2.5 Lakh in 15 Days With Zero Marketing Experience",
      para: "Sathish, from Pondicherry, had no prior digital marketing experience. But after joining Social Eagle’s Digital Entrepreneurship Program, everything changed. In just 15 days, he earned ₹2.5 Lakhs by applying the right strategies. Sathish’s journey shows how the right guidance can turn ambition into success, no matter your starting point.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/43.SEA Thumbnail Bhavana.webp"),
      mediaId: "43wcb5tigh",
      heading: "How Bhuvana, a Dietician, Earned 6 Figures in 6 Days Without Any Tech Skills",
      para: "Bhuvana, A dietician with no tech skills or marketing experience made over 6 figures in just 6 days after joining Social Eagle’s program. With the right strategies, she transformed her business, and now, she and her husband are reaping the rewards. The Social Eagle community and proven techniques were key to her incredible success.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/42.SEA Thumbnail Jahawar.webp"),
      mediaId: "9t9s972b4z",
      heading: "How Jawahar Earned $35,000 in 30 Days With Social Eagle’s Program",
      para: "Jawahar, a software developer, struggled with cheap courses that led nowhere. After joining Social Eagle’s program, he secured $35,000 in deals in just 30 days, with his client pipeline continuing to grow. He cracked the code to freelancing success, and now, he’s scaling up. Ready to elevate your freelancing career?",
    },
    // {
    //   thumbImg: require("../../assets/images/result-testi/41.SEA Thumbnail AswinRaaja.webp"),
    //   mediaId: "7zw3xumu1j",
    //   heading: "How Aswin Made ₹1 Lakh in 30 Days and Built a Thriving Agency",
    //   para: "Aswin Raajan, stuck in a stagnant job, yearned to break free and build something of his own. After joining Social Eagle’s Digital Entrepreneurship Program, he mastered lead generation, high-converting ads, and deal-closing strategies. In just 30 days, he earned over ₹1 Lakh and now runs a thriving digital agency. Aswin isn’t just making a living—he’s building a legacy.",
    // },
    {
      thumbImg: require("../../assets/images/result-testi/40.SEA Thumbnail Nishanthan.webp"),
      mediaId: "9g8qkzzo9u",
      heading: "How Nishanthan Went From ₹20K/Month to ₹1 Lakh+ in 8 Months",
      para: "Nishanthan, stuck in a ₹20K/month job, joined Social Eagle’s Digital Entrepreneurship Program with high hopes but faced 8 months without clients. Determined not to give up, he persevered. Now, he earns ₹80K+ monthly, has made over ₹1 Lakh, and leads a team. His journey proves persistence pays off.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/39.SEA Thumbnail Rizwanna.webp"),
      mediaId: "thmzi9vuur",
      heading: "How Rizwana Went From Zero Tech Skills to ₹4 Lakh in One Hackathon",
      para: "Rizwana had no tech skills or marketing knowledge, just a desire to succeed. After joining Social Eagle’s Digital Entrepreneurship Program, she generated 6-figure revenue, earning ₹4 Lakhs in a single hackathon. Now, she’s unstoppable, transforming her family’s future and building her empire. It all began with one leap.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/38.SEA Thumbnail Ajith.jfif"),
      mediaId: "k3fdj83vt2",
      heading: "How Ajith earned 8 Lakh in 30 days using real strategies from Social Eagle.",
      para: "Ajith, from the media industry, dreamed of owning an agency and gaining freedom. After joining Social Eagle’s program, he earned over ₹8 Lakh in under 30 days. With actionable strategies, he turned ambition into success, proving dreams are achievable with the right approach.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/46.SEA Thumbnail Sharon.webp"),
      mediaId: "vwx191su9q",
      heading: "From Homemaker to Successful Entrepreneur Sharon’s Digital Marketing Journey!.",
      para: "Sharon was a housewife who wanted to restart her career and build something of her own. With Social Eagle’s Digital Entrepreneurship Program, she learned digital marketing, started her own business, and became a successful business owner. No experience, just the right strategies and action.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/47.SEA Thumbnail Nivya.webp"),
      mediaId: "nrat0mmavq",
      heading: "Meet Niviya A Salon Owner Who Made Over 3+ Lakhs in Revenue!.",
      para: "Meet Niviya from Erode, who was running a salon business but wanted to grow beyond limits. After learning and implementing digital marketing strategies, she transformed her business and earned over 3 Lakhs in revenue. No fancy tricks—just real, practical steps that led to real results. Now, her salon is thriving, and she’s scaling faster than ever.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/48.SEA Thumbnail Rajkumar.webp"),
      mediaId: "e7d59i695a",
      heading: "From a 15L Salary to 4 Lakhs in 90 Days Working from Home!.",
      para: "Rajkumar had a 15L salary in the microfinance sector but wanted more. He joined Social Eagle’s Digital Entrepreneurship Program, and in 90 days, he earned 4 Lakhs—working from home. He didn’t just learn; he took action and changed his life!. No more limits. No more “what ifs.” Ready to make your leap?.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/49.SEA Thumbnail Lokeshwari.webp"),
      mediaId: "l5q6g3k45b",
      heading: "From Zero to 10 Lakhs: Lokeshwari's Remarkable Transformation!.",
      para: "Lokeshwari from Pondicherry was frustrated after spending big on an institute without seeing results. Her husband gifted her Social Eagle’s Digital Entrepreneurship Program, where she learned the right strategies, started her own agency, and launched a kids education academy. Now, they’re on track to earn 10 Lakhs!.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/50.SEA Thumbnail Giridharan.webp"),
      mediaId: "7q8vetuq39",
      heading: "How Giridharan Achieved a 2.5X Boost in Online Sales in Just 30 Days!",
      para: "Giridharan, an IT professional with 15 years of experience, joined Social Eagle inspired by his wife's encouragement. After learning digital marketing, he applied the strategies to his online book sales business. Previously using social media solely as a sales platform, he now leverages it effectively as a marketing tool, doubling his sales and achieving a 2.5x growth.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/51.SEA Thumbnail YesuDass.webp"),
      mediaId: "lsa85lqu7d",
      heading: "How Yasudass Doubled His Profits in the TV Repair Business with Smart Strategies!",
      para: "Yasudass was running a business when he realized he couldn't outshine the competition. He felt that without going online, he wouldn't be able to grow, and his business began to decline. He discovered the power of digital marketing and joined Social Eagle. After learning and implementing it in his business, he successfully doubled his revenue.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/52.SEA Thumbnail Vasu.webp"),
      mediaId: "dfyms7udy6",
      heading: "Meet Vasudavan A Design institute Owner Who Made Over 15+ Lakhs in Revenue!",
      para: "Vasudhavan, a design institute owner, struggled to market his business effectively despite his efforts. He attended Social Eagle Academy's webinar and was impressed by its structured approach to client handling. After joining the Digital Entrepreneurship Program in August 2024, he overcame his struggles and quickly learned key marketing strategies in his mother tongue, Tamil. Within a few months, he implemented these strategies and successfully grew his business, earning over 15 lakhs. Today, Vasudhavan is thriving as a successful entrepreneur.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/53.SEA Thumbnail Karthik N.webp"),
      mediaId: "cux81ixo8b",
      heading: "How Karthik Earned 90000₹ in just his 2nd Campaign (which even surprised Facebook)",
      para: "Karthik, an experienced entrepreneur, transitioned to digital strategies with Social Eagle's Digital Entrepreneurship Program. In just one month, he mastered marketing concepts and tailored his approach to his audience. His second campaign brought in 90k, surpassing years of prior experience. Karthik gained unparalleled insights and skills through mentorship and focused learning.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/54.SEA Thumbnail Bharathi.webp"),
      mediaId: "fo1k3jm9n1",
      heading: "How Bharathi Rachagan Earned 6.5 Lakhs and Cleared Her Debt.",
      para: "She had 5 years of work experience but felt stuck in repetitive tasks, which left her stressed and unfulfilled. Determined to make a change, she quit her job and joined a digital entrepreneurship program, funding it with a jewel loan. Despite having no prior business knowledge, she learned how to run ads, build networks, and grow her skills day by day. This was her first major investment in education, and it transformed her life. In just six months, she cleared her loan and earned nearly 6.5 lakhs, proving that the right opportunity can create remarkable results.",
    },
    // {
    //   thumbImg: require("../../assets/images/result-testi/54.SEA Thumbnail Bharathi.webp"),
    //   mediaId: "2uonnk976j",
    //   heading: "How Community Outsourcing Helped lekhashri to Earn 4 Lakhs",
    //   para: "Lekhashri loved learning in her mother tongue, Tamil, through Social Eagle's Digital Entrepreneurship Program. The one-month course and permanent community access stood out to her. By leveraging the community for outsourcing, she earned over 4 lakhs. Lekhashri believes true progress comes from investing in valuable skills that create real change, marking the turning point in your journey.",
    // },
    {
      thumbImg: require("../../assets/images/result-testi/63.Aiswarya Website Image.webp"),
      mediaId: "z8eo0cav85",
      heading:
        "How Aishwarya Earned 1.5 Lakhs in her Own Business",
      para: "Aishwarya Sriram always wanted financial independence but wasn’t sure how to achieve it. She joined Social Eagle’s Digital Entrepreneurship Program with the hope of building a successful digital career.Initially, she faced challenges in understanding digital strategies, but the mindset training and step-by-step guidance helped her gain confidence. By applying what she learned, she started attracting clients and generating revenue.Today, Aishwarya has successfully earned 1.5 lakhs, proving that the right guidance and dedication can lead to success. Her advice? Stay consistent, trust the process, and take action. Growth will follow!",
    },
    {
      thumbImg: require("../../assets/images/result-testi/64.balamurali Website Image.webp"),
      mediaId: "j3xl1jeqsi",
      heading:
        "How Balamurali Earned 2 Lakhs Using Digital Marketing",
      para: "Balamurali joined Social Eagle’s Digital Entrepreneurship Program with high hopes but faced initial struggles. Adapting to digital strategies wasn’t easy, and doubts crept in.However, instead of giving up, he stayed committed and applied the techniques taught in the program. With time, he started seeing results—securing clients and gradually building his revenue.Today, Balamurali has earned 2 lakhs through his efforts. His key takeaway? Persistence matters. Success comes when you trust the process and keep pushing forward.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/65.Edward Website Image.webp"),
      mediaId: "3nlyk97nyp",
      heading:
        "How Edward Earned 3 Lakhs and Became an Entrepreneur",
      para: "Edward is primarily a graphic designer, but after joining Social Eagle, he has significantly improved in his current job. With the encouragement of Social Eagle's mentors, he successfully sold three machines. At 49 years old, he had never received this kind of push before. He always wished for guidance, and now, having someone to support him throughout his journey has made a huge difference.  He feels grateful to the Social Eagle mentors, as their guidance has given him more strength and willpower to create meaningful change in his life. He realized that if he puts in the effort for a ₹1,000 job, he can earn ₹10,000 jobs in return. Doing a small job well leads to repeat opportunities.  Now, he is about to receive a ₹2.75 lakh cheque from a school client. Additionally, he has taken on a construction company as a client, earning approximately ₹50,000. In just a month, he has earned ₹3 lakhs, and he is set to receive another ₹3 lakh cheque soon. From the bottom of his heart, he thanks the entire Social Eagle team for their invaluable support.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/66.harikumar Website Image.webp"),
      mediaId: "nhey6dklx0",
      heading:
        "How Harikumar earned 2.5 lakhs within 60 Days in his Own Business",
      para: "Harikumar joined Social Eagle to promote his travel business by learning digital marketing. He believes that Social Eagle's biggest USP is its community, which has been extremely valuable to him. The community provides lifelong access, ensuring that someone is always there to support and guide him throughout his journey.Having a strong community gives us strength—we are never alone. The biggest advantage of a community is that we can see different perspectives. If there are 10 people, there will be 10 different viewpoints, leading to 10 possible solutions.  Through this program, Harikumar earned 2.5 to 3 lakhs in just two months. He believes that chances and opportunities are everywhere—we just need to use them wisely. As Dharani bro says,Everything is mindset. We should play very aggressively.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/67.jagan Website Image.webp"),
      mediaId: "cdlpnl4rzq",
      heading:
        "How Jagan Made 61 Lakhs in Revenue as a Digital Marketing Agency",
      para: "Jagan Mohanasundaram had big goals for his business but struggled to scale effectively. He needed the right strategies and a proven system to take his revenue to the next level. That’s when he joined Social Eagle’s Digital Entrepreneurship Program.With structured training, expert guidance, and mindset coaching, he refined his approach, implemented digital strategies, and unlocked massive growth.Now, Jagan has successfully generated ₹61 lakhs in revenue, proving that with the right knowledge and action, success is achievable.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/68.Jeevarathinam Website Image.webp"),
      mediaId: "cdlpnl4rzq",
      heading:
        "How Jeevarathinam Earned Around 5 Lakhs in her Business",
      para: "Jeevarathinam Balan had always wanted financial independence but struggled to find the right path. With no prior experience in digital entrepreneurship, he felt lost and unsure where to begin.After seeing inspiring success stories from Social Eagle, he took a leap of faith and joined the Digital Entrepreneurship Program. The mindset session transformed his approach—helping him identify potential clients, understand their needs, and position his services effectively.Today, Jeevarathinam has successfully built his digital business, earning around 5 lakhs. His advice? Trust the process, stay consistent, and follow Social Eagle’s guidance.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/69.kiran Website Image.webp"),
      mediaId: "bsgum716c0",
      heading:
        "How Kiran Made 1.7 Lakhs Revenue With One Client",
      para: "Kiran wanted to grow his business but needed the right strategies to land high-value clients. He joined Social Eagle’s Digital Entrepreneurship Program, hoping to gain clarity and direction.Through step-by-step training and expert guidance, he learned how to position his services effectively and attract premium clients. Applying these strategies, he secured a single client who brought in ₹1.7 lakhs in revenue.His advice? Focus on value, follow the proven system, and success will come—sometimes, just one client can change everything!",
    },
    {
      thumbImg: require("../../assets/images/result-testi/70.Lokesh Website Image.webp"),
      mediaId: "qbzlf3d67z",
      heading:
        "How Lokesh is Making 1 Lakh per Month Using Digital Marketing",
      para: "Lokesh always wanted a stable and scalable income but struggled to find the right approach. That’s when he joined Social Eagle’s Digital Entrepreneurship Program, looking for guidance and a proven system.With structured training and mindset coaching, he learned how to attract clients, optimize his business, and build a steady revenue stream. By applying these strategies consistently, he is now making ₹1 lakh per month.His advice? Follow the process, stay consistent, and success will become a habit!",
    },
    {
      thumbImg: require("../../assets/images/result-testi/71.marimuthu Website Image.webp"),
      mediaId: "5pid4apic3",
      heading:
        "How Marimuthu Earned 7 Lakhs with Digital Marketing",
      para: "Marimuthu stepped into Social Eagle’s Digital Entrepreneurship Program with hesitation. The journey wasn’t smooth—he faced setbacks, struggled to grasp new concepts, and even doubted whether digital entrepreneurship was right for him.But instead of quitting, he kept learning and implementing strategies from the program. Slowly, he gained clarity, secured clients, and built a steady income stream.Now, Marimuthu has earned 7 lakhs through his persistence and effort. His advice? Even when it gets tough, don’t give up. Follow the system, and results will come.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/72.meena Website Image.webp"),
      mediaId: "z7wcfxhsj8",
      heading:
        "While Learning How Meena Earned ₹70,000 in her Bank Exam Coaching Academy",
      para: "Meena Chenthil had a passion for teaching but needed help in growing her Bank Exam Coaching Academy. She wanted to reach more students and increase her revenue but lacked the right digital strategies.After joining Social Eagle’s Digital Entrepreneurship Program, she gained clarity on marketing, lead generation, and business scaling. Despite learning the ropes, she applied the strategies step by step—and started seeing results.Now, while still learning, Meena has earned ₹70,000, proving that you don’t have to wait to succeed. Her advice? Take action, trust the process, and results will follow",
    },
    {
      thumbImg: require("../../assets/images/result-testi/73.Moovendhira Raj Website Image.webp"),
      mediaId: "dtmvg2joqc",
      heading:
        "How Moovinthalraj Earned 1 Lakh in this Own Business",
      para: "Moovintharaj M wanted to grow his income but wasn’t sure where to start. He joined Social Eagle’s Digital Entrepreneurship Program, looking for the right strategies to build his business.Through expert guidance and step-by-step training, he learned how to attract clients and generate consistent revenue. By taking action and applying what he learned, he successfully earned ₹1 lakh.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/74.Nandhinee Muthu Website Image.webp"),
      mediaId: "151pe8axrt",
      heading:
        "How Nadhinee Muthu Earned ₹12 Lakhs in Business ",
      para: "Nadhinee Muthu had the passion and ambition to grow her business but needed the right direction. She joined Social Eagle’s Digital Entrepreneurship Program to learn effective digital strategies and scale her business.With the program’s structured training and mindset coaching, she transformed her approach, attracted more clients, and took her business to the next level.Now, Nadhinee has successfully earned ₹12 lakhs, proving that with the right guidance, success is achievable. Her advice? Stay committed, take action, and trust the process—big results will follow!",
    },
    {
      thumbImg: require("../../assets/images/result-testi/75.Nithyanad Website Image.webp"),
      mediaId: "ulsamejt5w",
      heading:
        "How Nithyanand Earned ₹90,000 in Business",
      para: "Nithyanand wanted to grow his business but needed the right strategies to attract clients and generate revenue. Looking for guidance, he joined Social Eagle’s Digital Entrepreneurship Program to learn the ropes of digital marketing and business growth.With the program’s step-by-step training and mindset coaching, he started applying proven strategies, which helped him gain momentum.Now, Nithyanand has successfully earned ₹90,000, proving that the right knowledge and action lead to results. His advice? Keep learning, take action, and trust the process—growth will follow!",
    },
    {
      thumbImg: require("../../assets/images/result-testi/76.rajesh Website Image.webp"),
      mediaId: "996nbsbxhg",
      heading:
        "How Rajesh M Made 1.5 Lakhs Revenue in his Business",
      para: "Rajesh M wanted to grow his income but wasn’t sure where to start. With no prior experience in digital entrepreneurship, he hesitated to take the leap.After joining Social Eagle’s Digital Entrepreneurship Program, he gained the right knowledge and strategies to build his business. By implementing what he learned, he started attracting clients and generating revenue.Now, Rajesh has successfully earned 1.5 lakhs, proving that the right guidance makes all the difference. His advice? Follow the system, stay consistent, and results will come!",
    },
    {
      thumbImg: require("../../assets/images/result-testi/77.Rasiga Website Image.webp"),
      mediaId: "7ed4glvt11",
      heading:
        "How Rasiga Rajavel Earned ₹6.5 Lakhs by leveraging Digital Marketing",
      para: "From Uncertainty to ₹6.5 Lakhs—Rasiga Rajavel’s Journey with Social Eagle Rasiga Rajavel wanted to grow her income but wasn’t sure where to start. She joined Social Eagle’s Digital Entrepreneurship Program, hoping to gain clarity and the right strategies to build a successful business.Through step-by-step training and mindset coaching, she learned how to attract clients, optimize her approach, and scale her business effectively.Now, Rasiga has successfully earned ₹6.5 lakhs, proving that dedication and the right guidance lead to results. Her advice? Take action, stay consistent, and success will follow!",
    },
    {
      thumbImg: require("../../assets/images/result-testi/78.sabarirajan Website Image.webp"),
      mediaId: "6yf29zr420",
      heading:
        "How Sabari Rajan Earned 2.8 Lakhs after quiting his Job",
      para: "Sabari Rajan S wanted to step into the world of digital entrepreneurship but wasn’t sure where to begin. He joined Social Eagle’s Digital Entrepreneurship Program, hoping to find the right guidance.At first, he faced challenges—learning new strategies and adapting to the digital landscape wasn’t easy. But with consistent effort and the program’s structured approach, he started seeing progress.Today, Sabari Rajan has successfully earned 2.8 lakhs, proving that persistence pays off. His advice? Keep learning, apply what you’re taught, and trust the process. Success follows effort!",
    },
    {
      thumbImg: require("../../assets/images/result-testi/79.Senthil GGS Website Image.webp"),
      mediaId: "rfzqhd3n9q",
      heading:
        "While Learning How Senthilkumar Earned More than 1.5 Lakhs Using Digital Marketing",
      para: "Senthilkumar G joined Social Eagle’s Digital Entrepreneurship Program to explore new opportunities, but he never expected to start earning so soon. While still learning the fundamentals of digital entrepreneurship, he applied the strategies step by step and began seeing results.By taking action and following the proven system, Senthilkumar has already earned more than 1.5 lakhs—all while continuing to enhance his skills.His advice? You don’t have to be an expert to start. Trust the process, implement what you learn, and success will follow!",
    },
    {
      thumbImg: require("../../assets/images/result-testi/80.sivaguru Website Image.webp"),
      mediaId: "shwwptohc9",
      heading:
        "How Sivaguru Earned Around 5 Lakhs in his Business ",
      para: "Sivaguru had the drive to grow his business but struggled to generate consistent income. Despite his efforts, he couldn’t scale effectively and needed the right strategy to move forward.After joining Social Eagle’s Digital Entrepreneurship Program, everything changed. The mindset training helped him refine his approach, identify opportunities, and implement digital strategies that worked.With dedication and the right guidance, Sivaguru has now earned around 5 lakhs in his business. His advice? Stay patient, follow the system, and take action—success will follow.",
    },
    {
      thumbImg: require("../../assets/images/result-testi/81.tamil ko Website Image.webp"),
      mediaId: "hys4kkrtmd",
      heading:
        "While Learning How Tamilko Earned ₹94,000 in Less than 1 Month",
      para: "Tamilko joined Social Eagle’s Digital Entrepreneurship Program with a desire to learn and grow. While still mastering the concepts, he decided to take action immediately and implement what he was learning.In less than a month, his efforts started paying off—he successfully earned ₹94,000, proving that results come when you apply the right strategies.His advice? Don’t wait until you know everything. Take action, follow the process, and success will come faster than you expect!",
    },
    {
      thumbImg: require("../../assets/images/result-testi/82.vimal vinoth Website Image.webp"),
      mediaId: "87c9q1s3bj",
      heading:
        "How Vimal Vinoth Started his Entrepreneurial Journey and Gained the Confidence to Scale his Business",
      para: "Vimal Vinoth always wanted to start his own business but lacked the confidence and direction to scale it. Unsure of how to navigate the digital landscape, he decided to join Social Eagle’s Digital Entrepreneurship Program for guidance.Through structured training and mindset coaching, he gained the clarity, strategies, and confidence needed to take action. Step by step, he implemented what he learned, setting his business on the path to growth.Now, Vimal is equipped to scale his business successfully, proving that the right support and persistence lead to results. His advice? Believe in yourself, apply what you learn, and success will follow!",
    },
  ];

  const handleOpenMedia = (media) => {
    console.log("clicked");
    setOpenVideo(true);
    setCurrentMediaId(media);
  };
  return (
    <div className="home-content-section">
      <div className="home-video-section  overflow-hidden py-5">
        <div className="container pt-5 ">
          <div className="row justify-content-between">
            <div
              className="col-lg-8"
              data-aos="fade-up-right"
              data-aos-duration="1500"
            >
              <div className="position-relative">
                {!isPlaying ? (
                  <div
                    onClick={() => setIsPlaying(true)}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      width="272" height="272"
                      src={VideoThumbnail}
                      alt="Thumbnail"
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "8px",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <img
                        width="272" height="272"
                        className="play-icon-video "
                        loading="lazy"
                        src={PlayIcon}
                        alt=""
                      ></img>
                    </div>
                  </div>
                ) : (
                  <wistia-player
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "12px",
                    }}
                    media-id="h0i55nsez3"
                    player-color="#D32B3A"
                  ></wistia-player>
                )}
              </div>
            </div>
            <div
              className="col-lg-3"
              data-aos="fade-up-left"
              data-aos-duration="1500"
            >
              <div>
                <p className="home-video-para">
                  <span className="span-red-content">
                    Tamil Nadu’s only Digital Entrepreneurship Program&nbsp;
                  </span>
                  <br className="break-tag" />
                  Focused on Data-Driven,
                  <br className="break-tag" /> AI Powered,
                  <br className="break-tag" /> Performance-Based,
                  <br className="break-tag" /> Customer-Obsessed, and
                  <br className="break-tag" /> Result-Oriented learning
                  <br className="break-tag" /> models.
                </p>
                <div className="position-relative">
                  <NavLink to={"/?id=home-below-section"} class="circle-div">
                    <div class="circle-center-link">
                      <div class="circle-center">
                        <img
                          width="96" height="96"
                          className="down-arrow-rotate"
                          loading="lazy"
                          src={DownArrow}
                          alt="Tick"
                        />
                      </div>
                      <div id="circle" class="rotate">
                        <svg width="300px" height="300px" viewBox="0 0 300 300">
                          <defs>
                            <path
                              id="circlePath"
                              d="M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0 "
                            ></path>
                          </defs>
                          <circle cx="150" cy="150" r="60" fill="none"></circle>
                          <g>
                            <use xlinkHref="#circlePath" fill="none"></use>
                            <text
                              fill="#fff"
                              font-size="10.5"
                              fontWeight="normal   "
                            >
                              <textPath xlinkHref="#circlePath">
                                &nbsp; &#183; &nbsp; FLY &nbsp; HIGH &nbsp; WITH
                                &nbsp; SOCIAL &nbsp; EAGLE &nbsp; &#183; &nbsp;
                                FLY &nbsp; HIGH &nbsp; WITH &nbsp; SOCIAL &nbsp;
                                EAGLE
                              </textPath>
                            </text>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="home-end-to-end-team-sections py-5 overflow-hidden"
        id="home-below-section"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <div className="">
                <h5
                  className="left-para-subContent arial-bold"
                  data-aos="fade-up-right"
                  data-aos-duration="1500"
                >
                  Complete End-to-End Digital Marketing
                  <br className="break-tag" /> Training which is Functional, AI
                  Powered,
                  <br className="break-tag" /> 100% Hands-on, Agency-Based &{" "}
                  <br className="break-tag" />
                  supported by Who’s Who of the Industry
                </h5>
                <div
                  className="position-relative mt-lg-5 mt-md-5 mt-0 width-left-circle-content"
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                >
                  <div class="circle-div">
                    <a href="#" class="circle-center-link">
                      <div class="circle-center-left">
                        <img
                          width="100" height="100"
                          className="circle-center-rotate-img"
                          loading="lazy"
                          src={Favicon}
                          alt="Tick"
                        />
                      </div>
                      <div id="circle" className="rotate">
                        <svg width="300px" height="300px" viewBox="0 0 300 300">
                          <defs>
                            <path
                              id="circlePath"
                              d="M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0"
                            ></path>
                          </defs>
                          <circle cx="150" cy="150" r="60" fill="none"></circle>
                          <g>
                            <use href="#circlePath" fill="none"></use>
                            <text fill="#fff" fontSize="11" fontWeight="bold">
                              <textPath href="#circlePath">
                                &nbsp; &#183; &nbsp; 10 &nbsp; YEARS &nbsp; OF
                                &nbsp; SOCIAL &nbsp; EAGLE &nbsp; &#183; &nbsp;
                                10 &nbsp; YEARS &nbsp; OF &nbsp; SOCIAL &nbsp;
                                EAGLE &nbsp;
                              </textPath>
                            </text>
                          </g>
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div data-aos="fade-up-left" data-aos-duration="1500">
                <img width="217" height="211" className="image-sections" loading="lazy" src={TeamHome} alt=""></img>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-choose-us-section overflow-hidden py-5">
        <div className="container">
          <div className="section-handson-sticky">
            <h2
              className="section-heading mb-5"
              data-aos="zoom-in"
              data-aos-duration="1500"
            >
              Why People Choose Us?
            </h2>
          </div>
          <div className="row justify-content-center py-3">
            <div className="col-lg-6">
              <div className="" data-aos="fade-right" data-aos-duration="1500">
                <h5 className="choose-us-sub-heading">Agency-Based Training</h5>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="" data-aos="fade-left" data-aos-duration="1500">
                <p className="choose-us-para-text">
                  From an Agency which has made Businesses over{" "}
                  <br className="break-tag" /> 100 crores in Revenue
                </p>
              </div>
            </div>
          </div>
          <hr />
          <div className="row justify-content-center py-3">
            <div className="col-lg-6">
              <div className="" data-aos="fade-right" data-aos-duration="1500">
                <h5 className="choose-us-sub-heading">
                  Year Long Support + Active Community
                </h5>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="" data-aos="fade-left" data-aos-duration="1500">
                <p className="choose-us-para-text">
                  52 Doubt Clearing Sessions
                  <br className="break-tag" /> Monthly Superstar Sessions +
                  Monthly Book Sessions
                </p>
                <p className="choose-us-para-text">
                  1000+ Positive Like-Minded People & Growing
                </p>
              </div>
            </div>
          </div>
          <hr />
          <div className="row justify-content-center py-3">
            <div className="col-lg-6">
              <div className="" data-aos="fade-right" data-aos-duration="1500">
                <h5 className="choose-us-sub-heading">
                  Entrepreneurship Skillset + <br className="break-tag" />
                  Mindset Training{" "}
                </h5>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="" data-aos="fade-left" data-aos-duration="1500">
                <p className="choose-us-para-text">
                  Through Online + Offline Sessions
                </p>
                <p className="choose-us-para-text">
                  Market-Ready Knowledge which works right now
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hands-on-section py-5">
        <div className="container">
          <div
            className="section-handson-sticky overflow-hidden"
            data-aos="zoom-in"
            data-aos-duration="1500"
          >
            <h2 className="section-heading">
              Hands-on. Disruptive. Result-Oriented.
            </h2>
            <h5 className="section-sub-heading mb-5">
              See how we teach our courses.
            </h5>
          </div>
          <div className="row">
            <div className="col-lg-3 position-relative">
              <div className="hands-on-left-content">
                <ul className="list-unstyled hands-on-content-mob pl-0">
                  {[
                    "Entrepreneurship",
                    "Knowledge",
                    "Training",
                    "Methodology",
                    "Community",
                    "Continuous Learning",
                    "Instructors",
                    "Business 101",
                    "Resources",
                    "Mentorship",
                  ].map((text, index) => (
                    <li key={index}>
                      <span
                        className={`hands-on-left-text ${activeTab === index ? "active" : ""
                          }`}
                        onClick={() => handleTabClick(index)}
                        ref={(el) => (videoRefs.current[index] = el)}
                      >
                        {text}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="hands-on-right-section">
                {handsOnContent.map((item, index) => (
                  <div
                    key={index}
                    className="hands-on-right-video position-relative"
                    ref={(el) => (videoRefs.current[index] = el)}
                    style={{ marginBottom: "16px" }}
                  >
                    {!isPlaying1[index] ? (
                      <div
                        onClick={() => handlePlay(index)}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={item.thumbImg}
                          loading="lazy"
                          alt="Thumbnail"
                          width="1280" height="720"
                          className="course-videos"
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                          }}
                        >
                          <img
                            width="272" height="272"
                            className="play-icon-video "
                            loading="lazy"
                            src={PlayIcon}
                            alt=""
                          ></img>
                        </div>
                      </div>
                    ) : (
                      <video
                        src={item.videoSrc}
                        poster={item.thumbImg}
                        controls
                        autoPlay
                        playsInline
                        className="course-videos"
                        style={{
                          width: "100%",
                          height: "450px",
                          objectFit: "cover",
                          borderRadius: "12px",
                        }}
                      />
                    )}
                    <p className="right-side-video-content-para">
                      {item.mediaPara}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-student-says-section overflow-hidden py-5">
        <div className="container mb-lg-0 mb-md-0 mb-5">
          <div className="section-handson-sticky">
            <h2
              className="section-heading mb-5"
              data-aos="zoom-in"
              data-aos-duration="2500"
            >
              What Our Students Say
            </h2>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="" data-aos="fade-up" data-aos-duration="1500">
                <OwlCarousel
                  className="owl-theme"
                  loop
                  autoplay={true}
                  items="1"
                  dots={false}
                  smartSpeed={2000}
                  autoplayHoverPause={true}
                  nav={true}
                  margin={20}
                  center={true}
                  autoplayTimeout={2000}
                  mouseDrag={false} // Disable mouse dragging
                  touchDrag={false}
                  responsive={{
                    360: {
                      items: "1",
                    },
                    414: {
                      items: "1",
                    },
                    670: {
                      items: "2",
                    },
                    992: {
                      items: "2",
                    },
                    1200: {
                      items: "3",
                    },
                  }}
                >
                  {videos.map((item, index) => {
                    return (
                      <div className="students-testi-card" key={index}>
                        <div className="">
                          <div className="position-relative">
                            <div onClick={() => handleOpenMedia(item.mediaId)}>
                              <img
                                width="1280" height="720"
                                className="stud-testi-card-img-home"
                                loading="lazy"
                                src={item.thumbImg}
                                alt="Thumbnail"
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: "5%",
                                  left: "3%",
                                }}
                              >
                                <img
                                  width="128" height="128"
                                  className="play-icon-video-testi pulse-button"
                                  loading="lazy"
                                  src={PlayIconTesti}
                                  alt=""
                                ></img>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="students-testi-card-content">
                          <h5 className="students-testi-heading">
                            {item.heading}
                          </h5>
                          <p className="mb-0 students-testi-para">
                            {item.para}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </OwlCarousel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="Home-award-section  overflow-hidden py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row justify-content-between">
                <div className="col-lg-6">
                  <div
                    className="home-award-left-img-section"
                    data-aos="zoom-in"
                    data-aos-duration="2500"
                  >
                    <img
                      width="639" height="992"
                      className="home-award-img"
                      loading="lazy"
                      src={HomeAward}
                      alt=""
                    ></img>
                  </div>
                </div>
                <div className="col-lg-5 my-auto">
                  <div
                    className="eagle-award-home-content"
                    data-aos="fade-left"
                    data-aos-duration="2500"
                  >
                    <h1 className="eagle-award-home-left-content">
                      Become a <br className="break-tag" />
                      Part of our <br className="break-tag" />
                      Community <br className="break-tag" />
                      & Win the <br className="break-tag" />
                      Prestigious <br className="break-tag" />
                      <span className="eagle-award-gradient">Eagle Award</span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="results-content">
        <CustomModal
          open={openVideo}
          onClickOutside={() => {
            setOpenVideo(false);
            setCurrentMediaId(null);
          }}
        >
          <div className="modal-content contact-container m-auto">
            <div className="modal-body w-100 p-0 ">
              <div className="close-btn">
                <i
                  className="fa-regular fa-circle-xmark"
                  onClick={() => setOpenVideo(false)}
                ></i>
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="">
                      <wistia-player
                        style={{
                          width: "100%",
                          height: 420,
                          borderRadius: 12,
                        }}
                        media-id={currentMediaId}
                        player-color="#D32B3A"
                      ></wistia-player>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CustomModal>
      </div>
    </div>
  );
};
